import { __ } from '../utils';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@presov.sk/presov-ui-react';
import React from 'react';

type Props = {
  open: boolean;
  title?: string | React.ReactNode;
  description?: string;
  formId?: string;
  confirmLabel: string;
  closeLabel?: string;
  isLoading?: boolean;
  confirmDisabled?: boolean;
  onConfirm?: (e: React.MouseEvent) => Promise<void> | void;
  onClose: () => void;
  fullWidth?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
  buttons?: React.ReactNode;
} & React.PropsWithChildren;

export const ConfirmationDialog: React.FC<Props> = ({
  open,
  formId,
  confirmLabel,
  closeLabel = __('Zavrieť'),
  title,
  description = '',
  children,
  onClose,
  onConfirm,
  isLoading = false,
  confirmDisabled = false,
  fullWidth = false,
  maxWidth,
  buttons,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      {title && (
        <DialogTitle
          sx={{
            display: 'flex',
          }}
        >
          {title}
        </DialogTitle>
      )}
      {(children || description) && (
        <DialogContent>
          {description && <DialogContentText>{description}</DialogContentText>}
          {children}
        </DialogContent>
      )}
      <DialogActions sx={{ justifyContent: 'space-between', px: 2.5, py: 1.5 }}>
        {buttons}
        <Stack direction={'row'} spacing={1} sx={{ marginLeft: 'auto' }}>
          <Button onClick={onClose} disabled={isLoading} variant='text'>
            {closeLabel}
          </Button>
          {formId ? (
            <Button
              type='submit'
              form={formId}
              disabled={isLoading || confirmDisabled}
              loading={isLoading}
            >
              {confirmLabel}
            </Button>
          ) : (
            <Button
              onClick={onConfirm}
              disabled={isLoading || confirmDisabled}
              loading={isLoading}
            >
              {confirmLabel}
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
